import { createClient, createDyProvider, DyTemplates } from '../lib/dy';
import { DyMultiVariationTemplates } from '../lib/dy/types';
import { DYHeroBannerWithCTAButtons } from '../components/dy/DYHeroBannerWithCTAButtons';
import { DYHeroBannerSingleCTA, DYHeroBannerSingleCTAGrid } from '../components/dy/DYHeroBannerSingleCTA';
import { DYExitIntent } from '../components/dy/DYExitIntent';
import { DYHeroBanner } from '../components/dy/DYHeroBanner';
import { DYImageBanner } from '../components/dy/DYImageBanner';
import { DYMessageBanner } from '../components/dy/DYMessageBanner';
import { DYFilterSlider } from '../components/dy/DYFilterSlider';
import { getPublicRuntimeConfig } from '../helpers/getPublicRuntimeConfig';
import { DYImageSlider } from '../components/dy/DYImageSlider';

const DY_CLIENT_SIDE_API_KEY = getPublicRuntimeConfig('DY_CLIENT_SIDE_API_KEY');
const DY_SERVER_SIDE_API_KEY = getPublicRuntimeConfig('DY_SERVER_SIDE_API_KEY');

const templates: DyTemplates = {
  EXIT_INTENT: DYExitIntent,
  HERO_BANNER: DYHeroBanner,
  HERO_BANNER_SINGLE_CTA: DYHeroBannerSingleCTA,
  HERO_BANNER_SINGLE_CTA_GRID: DYHeroBannerSingleCTAGrid,
  HERO_BANNER_WITH_4_CTA: DYHeroBannerWithCTAButtons,
  IMAGE_BANNER: DYImageBanner,
  MESSAGE_BANNER: DYMessageBanner,
};

const multiVariationTemplates: DyMultiVariationTemplates = {
  FILTER_SLIDER: {
    dataMergeProp: 'ctas',
    Component: DYFilterSlider,
  },
  IMAGE_SLIDER: {
    dataMergeProp: 'items',
    Component: DYImageSlider,
  },
};

export const dyClient = createClient({
  clientSideApiKey: DY_CLIENT_SIDE_API_KEY,
  serverSideApiKey: DY_SERVER_SIDE_API_KEY,
});

export const DyProvider = createDyProvider({
  client: dyClient,
  templates,
  multiVariationTemplates,
});
